import React from 'react';
import './prayerpage.styles.css';
import {getTimeTable} from './prayer.js';

const PrayerPage = () => { 
    return (    
            <div className='prayercontainer'>
                <h1>مواقيت الصلاة</h1><h3>Gulf Sys.</h3> 
                <br/>
                <h2 className='locationname' id='locationname'></h2>
                <br/>
                <input className='timeTableButton' id='timeTableButton' type='button' value='view time table' onClick={getTimeTable}/>
                <br/>
                <div className='title1 horizontal'> 
                    <h3>إمساك</h3>
                    <h4 className='prayer-element' id='prayer-element-1'></h4>
                    <h3>Imsak</h3>
                </div>
                <div className='title1 horizontal'> 
                    <h3>الفجر</h3>
                    <h4 className='prayer-element' id='prayer-element-2'></h4>
                    <h3>Fajr</h3>
                </div>
                <div className='title2 horizontal'> 
                    <h3>الشروق</h3>
                    <h4 className='prayer-element' id='prayer-element-3'></h4>
                    <h3>Sunrise</h3>
                </div>
                <div className='title2 horizontal'> 
                    <h3>الظهر</h3>
                    <h4 className='prayer-element' id='prayer-element-4'></h4>
                    <h3>Dhuhr</h3>
                </div>
                <div className='title3 horizontal'> 
                    <h3>العصر</h3>
                    <h4 className='prayer-element' id='prayer-element-5'></h4>
                    <h3>Asr</h3>
                </div>
                <div className='title3 horizontal'> 
                    <h3>الغروب</h3>
                    <h4 className='prayer-element' id='prayer-element-6'></h4>
                    <h3>Sunset</h3>
                </div>
                <div className='title4 horizontal'> 
                    <h3>المغرب</h3>
                    <h4 className='prayer-element' id='prayer-element-7'></h4>
                    <h3>Maghrib</h3>
                </div>
                <div className='title4 horizontal'> 
                    <h3>العشاء</h3>
                    <h4 className='prayer-element' id='prayer-element-8'></h4>
                    <h3>Isha</h3>
                    <br/><br/>
                </div>
                <h4>علوم التفسير والحديث والتاريخ</h4>
                <h3> إهداء إلي المعلمة عنود غريب المطيري - نسأل الله لها الرحمه</h3>
                <br/><br/><br/><br/>
            </div>
            );
};  
export default PrayerPage;